import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import type { FileSimpleDTO } from '../file.types';
import BaseUserDTOModel from '@repositories/userRepository/models/BaseUserDTOModel';

export class FileSimpleModel {
  private readonly _dto: FileSimpleDTO;
  private readonly _creator: BaseUserDTOModel | undefined;
  private readonly _updater: BaseUserDTOModel | undefined;

  constructor(dto: FileSimpleDTO) {
    this._dto = dto;
    this._creator = dto.creator ? new BaseUserDTOModel(dto.creator) : undefined;
    this._updater = dto.updater ? new BaseUserDTOModel(dto.updater) : undefined;
  }

  get originDTO(): FileSimpleDTO {
    return this._dto;
  }

  get fileExtension(): string {
    return this._dto.fileExtension || '';
  }

  get fileId(): string {
    return this._dto.fileId || '';
  }

  get fileSize(): number {
    return this._dto.fileSize || 0;
  }

  get originalName(): string {
    return this._dto.originalName || '';
  }

  get fileName() {
    const splitted = this.originalName.split('.');
    if (splitted.length > 0 && splitted[splitted.length - 1] === this.fileExtension) {
      return splitted.slice(0, splitted.length - 1).join('.');
    }
    return this.originalName;
  }

  get createdBy(): string {
    return this._dto.createdBy || '';
  }

  get createdDate(): Dayjs {
    return dayjs(this._dto.createdDate) || dayjs();
  }

  get updatedBy(): string {
    return this._dto.updatedBy || '';
  }

  get updatedDate() {
    return dayjs(this._dto.updatedDate) || dayjs();
  }

  get creator(): BaseUserDTOModel | undefined {
    return this._creator;
  }

  get updater(): BaseUserDTOModel | undefined {
    return this._updater;
  }
}
